import React from 'react';
import { isEmpty } from 'lodash';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';
import SummaryWrapper from '../../../components/MUI/SummaryWrapper';
import TitleTypography from '../../../components/MUI/TitleTypography';
import Details from '../../../components/MUI/SummaryWrapper/Details';
import DisplayPrice from '../../../components/DisplayPrice';
import ContractDetailsSection from './ContractDetailsSection';
import { isArmenianLanguage } from '../../../helpers/langHelpers';
import { ONCO_CARE_CONTRACT_LINK } from '../../../constants/oncoCare';

import useStyles from '../../../components/MUI/SummaryWrapper/makeStyles';

const ContractSummary = ({
  contractSummary,
  openMobileSummary,
  onDismiss,
  range,
  isFetchingPrice,
  amount,
  riskAmount,
  paymentFrequency,
}) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  return (
    <SummaryWrapper openMobileSummary={openMobileSummary} onDismiss={onDismiss}>
      <Grid item xs={12} className={classes.sectionBox}>
        {!isEmpty(contractSummary) && (
          <>
            <TitleTypography component="div" className={classes.sectionTitle}>
              {t('contract.summary')}
            </TitleTypography>
            <Grid item className={classes.sectionRow}>
              <Details details={contractSummary} />
            </Grid>
          </>
        )}
      </Grid>
      <Grid container className={classes.summaryTotal}>
        <Grid item className={classes.summaryTotalLabel}>
          {t(paymentFrequency.translationPath)}
          {
            isArmenianLanguage(i18n.language) ? <br /> : ' '
          }
          <span className={classes.oncoCareSummaryTotalLabel}>{t('contract.summaryTotal')}</span>
        </Grid>
        <Grid item className={cn(classes.summaryTotalAmount, classes.oncoCareSummaryTotalAmount)}>
          <DisplayPrice price={amount} isFetching={isFetchingPrice} />
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.sectionBox}>
        <TitleTypography
          component="a"
          href={ONCO_CARE_CONTRACT_LINK[i18n.language]}
          target="_blank"
          className={classes.sectionTitle}
        >
          {t('insurance.contractDetails')}
        </TitleTypography>
        <Grid item className={classes.sectionRow}>
          <ContractDetailsSection
            range={range}
            riskAmount={riskAmount}
          />
        </Grid>
      </Grid>
    </SummaryWrapper>
  );
};

ContractSummary.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  openMobileSummary: PropTypes.bool.isRequired,
  contractSummary: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  range: PropTypes.shape({
    start: PropTypes.instanceOf(Date),
    end: PropTypes.instanceOf(Date),
  }),
  isFetchingPrice: PropTypes.bool,
  amount: PropTypes.number,
  riskAmount: PropTypes.number,
  paymentFrequency: PropTypes.shape({
    translationPath: PropTypes.string,
    value: PropTypes.string,
    paymentCount: PropTypes.number,
  }).isRequired,
};

ContractSummary.defaultProps = {
  range: {},
  amount: 0,
  isFetchingPrice: false,
  riskAmount: 0,
};

export default ContractSummary;
